import { gql } from "@apollo/client";

export const createTarget = gql`
  mutation CreateTarget(
    $broker_id: ID!
    $target_name: String!
    $start_date: String!
    $end_date: String!
    $base_currency: String!
  ) {
    createTarget(
      broker_id: $broker_id
      target_name: $target_name
      start_date: $start_date
      end_date: $end_date
      base_currency: $base_currency
    )
  }
`;

export const createTargetBadges = gql`
  mutation CreateTargetBadges($target_id: ID!, $badges: [TargetBadgeInput!]!) {
    createTargetBadges(target_id: $target_id, badges: $badges)
  }
`;

export const updateTarget = gql`
  mutation updateTarget(
    $id: ID!
    $target_name: String!
    $start_date: String!
    $end_date: String!
    $base_currency: String!
  ) {
    updateTarget(
      id: $id
      target_name: $target_name
      start_date: $start_date
      end_date: $end_date
      base_currency: $base_currency
    )
  }
`;

export const deleteTarget = gql`
  mutation DeleteTarget($id: ID!) {
    deleteTarget(id: $id)
  }
`;
